var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.players,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(rank)",fn:function(data){return [_vm._v(" "+_vm._s(data.index + 1)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }